import React, { useEffect } from "react";
import { CommentDetail, HeaderConfig, ProgramContainer } from "../../../entities/formTemplateDataType";
import CMACommentComponent from "./CMACommentComponent";
import { format } from "date-fns";
import { TabMenu } from "primereact/tabmenu";
import { set } from "lodash";
import CMAUtils from "../../../utilities/CMAUtils";
import success from "src/theme/icons/success";

const tabItems = [
    { label: 'All coments' },
    { label: 'Unresolved comments' },
];

const CMACommentListComponent = ({
    programContainer,
    headerConfig,
    comments,
    cmaRole,
    profile,
    callback,
    cancelComments,
    callbackCMASaved,
}: {
    programContainer: ProgramContainer,
    headerConfig: HeaderConfig,
    comments?: CommentDetail[],
    cmaRole: 'A' | 'C',
    profile?: any,
    callback: (p: ProgramContainer) => void,
    cancelComments: () => void,
    callbackCMASaved: () => void
}) => {
    const [commentList, setCommentList] = React.useState<CommentDetail[]>(
        comments?.filter(c => c.func === headerConfig.func && c.category === headerConfig.category) ?? []
    );
    const [newComment, setNewComment] = React.useState<CommentDetail>({ Comments: '', MadeBy: '', MadeOn: '', role: cmaRole });
    const [updated, setupdated] = React.useState(false);
    const [activeTab, setActiveTab] = React.useState(0);

    const setComment = (value: string, comment: CommentDetail, index?: number, resolved = false) => {
        if (index < 0) {
            // edit new comment
            setNewComment({ ...newComment, Comments: value, Resolved: resolved, role: cmaRole });
            setupdated(true);
            return;
        }

        const comments = commentList.map((c, i) => {
            if (i === index) {
                return { ...c, Resolved: resolved, };
            }
            return c;
        });
        setupdated(true);
        setCommentList(comments);
        updateComments(comments);
        CMAUtils.saveCMA(programContainer, programContainer.Entity?.status).then(success => {
            if (success) {
                callbackCMASaved();
            }
        });
    }

    const sendComments = (e) => {
        console.log('sendComments', updated);
        if (!updated) return;
        const comments = [...commentList]
        e.preventDefault();
        if (newComment.Comments) {
            const comment = {
                ...newComment,
                MadeBy: profile?.Email,
                MadeOn: format(new Date(), 'yyyy-MM-dd HH:mm:ss'),
                role: cmaRole,
                category: programContainer.HeaderConfig?.category,
                func: programContainer.HeaderConfig?.func,
            }
            comments.push(comment);
            setCommentList(comments);
        }
        setNewComment({ Comments: '', MadeBy: '', MadeOn: '', role: cmaRole });
        setupdated(false);
        updateComments(comments);
        CMAUtils.saveCMA(programContainer, programContainer.Entity?.status).then(success => {
            if (success) {
                callbackCMASaved();
            }
        })
    }

    const handleCancelComments = () => {
        setNewComment({ Comments: '', MadeBy: '', MadeOn: '', role: cmaRole });
        setupdated(false);
        cancelComments();
    }

    const deleteComment = (index: number) => {
        const comments = commentList.filter((c, i) => i !== index);
        setCommentList(comments);
        setupdated(true);
        updateComments(comments);
        CMAUtils.saveCMA(programContainer, programContainer.Entity?.status).then(success => {
            if (success) {
                callbackCMASaved();
            }
        });
    }

    const updateComments = (updatingComments: CommentDetail[]) => {
        if (updatingComments.length === 0) return;
        const comments = programContainer.Entity.comments?.
            filter(c => c.func !== headerConfig.func && c.category !== headerConfig.category) ?? [];
        updatingComments.forEach(c => comments.push(c));
        programContainer.Entity.comments = comments;
        callback(programContainer);
    }

    useEffect(() => {
        let tab = activeTab;
        let list = comments?.filter(c => c.func === headerConfig.func && c.category === headerConfig.category) ?? [];
        if (list.filter(c => !c?.Resolved).length === 0) {
            tab = 0;
        } else {
            list = tab === 0 ? list : list.filter(c => !c?.Resolved);
        }
        setCommentList(list);
        setActiveTab(tab);
    }, [comments])

    // useEffect(() => {
    //     const handleSendComments = (e) => {
    //         console.log('handleSendComments', e.target.closest('.message-items'), e.target.closest('.pop-up-button.ontario-button--primary'));
    //         if (e.target.closest('.message-items') && e.target.closest('.pop-up-button.ontario-button--primary')) sendComments(e);
    //     }

    //     document.addEventListener('click', handleSendComments);
    //     return () => {
    //         document.removeEventListener('click', handleSendComments);
    //     }
    // }, []);

    return (
        <>
            {comments.filter(c => !c?.Resolved).length > 0 && (
                <div className="tabs-section tabs-background">
                    <TabMenu model={tabItems}
                        activeIndex={activeTab}
                        onTabChange={(e) => setActiveTab(e.index)}
                    />
                </div>
            )}

            {commentList?.filter(c => activeTab === 1 ? !c.Resolved : true).map((comment, index) => (
                <ul className="message-items">
                    <li key={`comment-${index}`}>
                        <CMACommentComponent
                            data={comment}
                            index={index}
                            cmaRole={cmaRole}
                            isCommentOwner={comment.MadeBy?.toLocaleLowerCase() === profile?.Email?.toLocaleLowerCase}
                            setComment={(value, index, resolved) => setComment(value, comment, index, resolved)}
                            deleteComment={deleteComment}
                            status={programContainer.Entity?.status}
                        />
                    </li>
                </ul>
            ))}
            {activeTab === 0 && (
                <ul className="message-items">
                    <li key={`comment-${comments.length}`}>
                        <p className="ontario-margin-bottom-16-!"><span style={{ fontWeight: '600' }}>Add a comment</span></p>
                        <CMACommentComponent
                            data={newComment}
                            newComment={true}
                            index={comments.length}
                            cmaRole={cmaRole}
                            isCommentOwner={true}
                            status={programContainer.Entity?.status}
                            setComment={(value, index) => setComment(value, newComment, -1)}
                            deleteComment={deleteComment}
                        />
                    </li>
                    <li key='comment-button'>
                        <div style={{ display: 'flex', justifyContent: 'flex-start', flexWrap: 'wrap' }}>
                            <button className="pop-up-button ontario-button--primary" disabled={!updated} onClick={sendComments}>Send</button>
                            <button className="pop-up-button ontario-button--secondary" onClick={handleCancelComments}>Cancel</button>
                        </div>
                    </li>
                </ul>
            )}
        </>
    );
}

export default CMACommentListComponent;